import { CampaignModal } from './CampaignOverlays.jsx';
import { Button } from '../primitives.jsx';

export function CampaignBillingAccessNotice({ decision, onViewBilling, onRefresh }) {
  if (!decision || decision.allowed) return null;
  return <div className="bl-campaign-action-notice bl-campaign-billing-access" role="note">
    <strong>{decision.title}</strong><span>{decision.description}</span>
    {decision.reason === 'subscription_required' && onViewBilling && <Button variant="ghost" size="sm" type="button" onClick={onViewBilling}>View Billing</Button>}
    {decision.reason !== 'subscription_required' && onRefresh && <Button variant="ghost" size="sm" type="button" onClick={onRefresh}>Check status</Button>}
  </div>;
}

export function CampaignBillingAccessDialog({ decision, serverDenied = false, onClose, onViewBilling, onRefresh }) {
  const current = serverDenied ? { allowed: false, reason: 'subscription_required', title: 'Paid access is required', description: 'The server did not confirm paid access for this action. Review your company subscription in Billing before trying again.' } : decision;
  if (!current || current.allowed) return null;
  return <CampaignModal title={current.title} description={current.description} onClose={onClose}
    footer={<><button type="button" data-campaign-safe-focus onClick={onClose}>Keep browsing</button>
      {current.reason === 'subscription_required'
        ? <button type="button" className="is-primary" onClick={onViewBilling}>View Billing</button>
        : <button type="button" className="is-primary" onClick={onRefresh}>Check status</button>}</>} />;
}
